<template>
    <aside aria-label="Login">
        <slide-in-overlay :is-open="isOpen" @close="close" class="c-map">
            <template v-slot:heading>
                {{ translations['Find store'] }}
            </template>

            <template v-slot:body>
                <img alt="Minifabrikken lokation" src="/images/map.jpg" />
                <div class="c-map__adress">
                    <slot name="address"></slot>
                </div>
            </template>

            <template v-slot:footer>
                <div class="c-map__buttons">
                    <a
                        rel="noopener"
                        :href="link"
                        target="_blank"
                        class="o-btn o-btn--fullwidth"
                        >{{ translations['Show the way'] }}</a
                    >
                </div>
            </template>
        </slide-in-overlay>
    </aside>
</template>

<script>
import { mapState } from 'vuex'

import SlideInOverlay from '../components/SlideInOverlay.vue'
import InlineLoader from './InlineLoader.vue'

export default {
    name: 'MapSlidein',
    components: {
        SlideInOverlay,
        InlineLoader,
    },
    data: () => {
        return {}
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        link: {
            type: String,
        },
    },
    computed: {
        ...mapState({
            translations: (state) => state.app.translations,
        }),
    },
    methods: {
        close() {
            this.$store.commit('app/setMapVisibility', false)
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-map {
    .c-slideInOverlay__inner {
        max-width: 392px;
    }

    .c-slideInOverlay__body {
        padding: 0;
    }

    .o-contactinfo {
        padding: 30px;

        &__address {
            margin-top: 0;
            margin-bottom: 7px;
        }
    }

    &__actions {
        margin-top: 40px;
        text-align: center;

        .return {
            font-size: 12px;
            text-transform: uppercase;
            font-weight: 700;

            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>

